import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import apiUser from "../../apiUser";
import ManualModal from "./Manuals/ManualModal";
import AdjustModal from "./Adjust/AdjustModal";
import {useTecRmi} from "../../contexts/TecRmiContext";

const TextLinkType = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [itemMp, setItemMp] = useState()
  const [adjustItemMpId, setAdjustItemMpId] = useState()

  const getItemMp = () => {
    apiUser.tecRmi.manuals.linkedTechnicalManuals({
      ...getApiPrimaryParams(),
      itemMpId: props.linkValue,
    })
      .then(res => {
        setItemMp(res.data)
      })
  }

  const getLink = () => {
    if(!props.linkValue){
      return props.children;
    }

    switch (props.linkType) {
      case 32: {
        return props.children;
      }
      case 97: {
        return <Link to={'#'} className="text-primary font-weight-bold" onClick={() => setAdjustItemMpId(props.linkValue)}>{props.children}</Link>
      }
      case 105: {
        return <Link to={'#'} className="text-primary font-weight-bold" onClick={getItemMp}>{props.children}</Link>
      }
      default: {
        return <Link to={'#'} className="text-primary font-weight-bold" onClick={() => console.log('brak implementacji', props)}>{props.children}</Link>;
      }
    }
  }

  return <React.Fragment>
    {getLink()}
    {itemMp && <ManualModal
      onClose={() => setItemMp(null)}
      itemMp={itemMp}
    />}
    {adjustItemMpId && <AdjustModal
      onClose={() => setAdjustItemMpId(null)}
      itemMpId={adjustItemMpId}
    />}
  </React.Fragment>
};

TextLinkType.propTypes = {
  linkType: PropTypes.number.isRequired,
  linkValue: PropTypes.number,
};

export default TextLinkType;